import { Service } from '@angular/core';

@Service()
export class ScrollService {
  scrollToTop() {
    const scrollContainer = this._getScrollContainer();
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  scrollToElementById(id: string) {
    const el = this._getElementById(id);
    if (el) {
      this.scrollToElement(el);
    }
  }

  private _getScrollContainer(): HTMLElement | null {
    return document.querySelector('#taskListContainer') || document.body;
  }

  private _getElementById(id: string): HTMLElement | null {
    return document.getElementById(id);
  }

  private scrollToElement(element: HTMLElement) {
    // 'nearest', not 'center', because the overlay-scrollbar list is a few px wider than its viewport, so 'center'
    // sets scrollLeft > 0 and clips the resolved row's left accent border.
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });
  }
}
